import React from "react";
import { FormGroup, Label } from "reactstrap";
import { Controller } from "react-hook-form";
import { AntInput } from "../../../CommonElements/AntInput";
import { useTranslation } from "react-i18next";

export const PortForm = (props) => {
  const { control, errors } = props;
  const { t } = useTranslation();

  return (
    <>
      <FormGroup className="mb-3">
        <Controller
          control={control}
          name="name_ar"
          rules={{
            required: t("PORT_NAME_REQUIRED"),
          }}
          render={({ field }) => (
            <>
              <Label for="name_ar">{t("PORT_NAME")}</Label>
              <AntInput
                type="text"
                id="name_ar"
                name="name_ar"
                {...field}
                placeholder={t("PORT_NAME_PLACEHOLDER")}
              />
              {errors?.name_ar && (
                <div className="text-danger">{errors.name_ar.message}</div>
              )}
            </>
          )}
        />
      </FormGroup>
      <FormGroup className="mb-3">
        <Controller
          control={control}
          name="name_en"
          rules={{
            required: t("PORT_NAME_EN_REQUIRED"),
          }}
          render={({ field }) => (
            <>
              <Label for="name_en">{t("PORT_NAME_EN")}</Label>
              <AntInput
                type="text"
                id="name_en"
                name="name_en"
                {...field}
                placeholder={t("PORT_NAME_EN_PLACEHOLDER")}
              />
              {errors?.name_en && (
                <div className="text-danger">{errors.name_en.message}</div>
              )}
            </>
          )}
        />
      </FormGroup>
      <FormGroup className="mb-3">
        <Controller
          control={control}
          name="code"
          rules={{
            required: t("PORT_CODE_REQUIRED"),
          }}
          render={({ field }) => (
            <>
              <Label for="code">{t("PORT_CODE")}</Label>
              <AntInput
                type="text"
                id="code"
                name="code"
                {...field}
                placeholder={t("PORT_CODE_PLACEHOLDER")}
              />
              {errors?.code && (
                <div className="text-danger">{errors.code.message}</div>
              )}
            </>
          )}
        />
      </FormGroup>
    </>
  );
};

